import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import InnerHeader from "../../components/InnerHeader/InnerHeader";
import Input from "../../components/Input/Input";
import ThemeBtn from "../../components/ThemeBtn/ThemeBtn";
import { register } from "../../api/LoginService";
import FetchService from "../../api/FetchService";
import LoadingOverlay from "react-loading-overlay";
import { ImageUploader } from "../../utility-components/ImageUploader/ImageUploader";
import {getAllActivityCategories, getFilters} from "../../commons/activity-filters/Helpers";
import { useLocation } from "react-router-dom";

import { Swiper, SwiperSlide } from "swiper/react";
import { EffectFade, Autoplay, Pagination } from "swiper";

import 'swiper/swiper-bundle.min.css';

import Form from "react-bootstrap/Form";
import "./EditActivity.scss";
import AttachActivity from "../AttachActivity/AttachActivity";
import DialogueBox from "../../components/DialogueBox/DialogueBox";
import { API } from "../../api/API-Url";
import deleteImg from "../../img/remove.png";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import TransportSelector from "../../components/TransportSelector/TransportSelector";

const priceModelArray = [
  { label: "Per person", value: "person" },
{ label: "Per aktivitet", value: "activity" },
{ label: "Per time", value: "time" },

];

let activityRequest = {
  id: 0,
  name: "",
  activityType: "",
  city: "",
  price: 0,
  childoriginalPrice: 0,
  childprice: 0,
originalPrice: 0,
  validPeriodEnd: "",
  validPeriodStart: "",
  liveDate: "",
  terms: "",
  description: "",
  imagePath: "",
  instagram: null,
  facebook: null,
  youtube: null,
  priceModel: "person",
  minPerson: 0,
  maxPerson: 0,
  discountPercent: 0,
  addDate: new Date().toISOString().slice(0, 10),
};

function EditActivity({ setIsLoading }) {
  const location = useLocation();
  const initialActivity = location.state;


  const [activity, setActivity] = useState(initialActivity);

    const [giftCardFavPriority, setGiftCardFavPriority] = useState(activity.giftCardFavPriority);
    const [categoryFavPriority, setCategoryFavPriority] = useState(activity.categoryFavPriority);


  const [showConfirmDelete, setShowConfirmDelete] = useState(false);

  const [showImagePreview, setShowImagePreview] = useState(false);
  const [name, setName] = useState(activity.name);
    const [type, setType] = useState(activity.activityType);
    let acity;
    if (activity.city === null) {
        acity = [];
    } else {
        acity = activity?.city?.split(", ");
    }
    const [city, setCity] = useState(acity);

  const [originalPrice, setOriginalPrice] = useState(activity.originalPrice);
  const [price, setPrice] = useState(activity.price);


    const [childoriginalPrice, setchildOriginalPrice] = useState(activity.childOriginalPrice);
    const [childprice, setChildPrice] = useState(activity.childPrice);


  const [priceModel, setPriceModel] = useState(activity.priceModel);

    const [images, setImages] = useState(activity?.images ? JSON.parse(activity.images): null);
    const addImage = (newImage) => {
        setImages((prevImages) => [...prevImages, newImage]);
    };
  const [validPeriodStart, setValidPeriodStart] = useState
    (activity.validPeriodStart?.slice(0, 10)
  );
  const [validPeriodEnd, setValidPeriodEnd] = useState(
    activity.validPeriodEnd?.slice(0, 10)
  );

  const [liveDate, setLiveDate] = useState(activity.liveDate?.slice(0, 10));

  const [instagram, setInstagram] = useState(activity.instagram);
  const [facebook, setFacebook] = useState(activity.facebook);
  const [youtube, setYoutube] = useState(activity.youtube);

  const [terms, setTerms] = useState("");
  const [description, setDescription] = useState(activity.description);

  const [minPerson, setMinPerson] = useState(activity.minPerson);
  const [maxPerson, setMaxPerson] = useState(activity.maxPerson);
  const [category, setCategory] = useState(activity.category);

   const [hasCancellation, setHasCancellation] = useState(activity?.cancellationDeadlineDays > 0 ? true : false);
   const [deadlineDays, setDeadlineDays] = useState(activity?.cancellationDeadlineDays > 0 ? activity?.cancellationDeadlineDays : null);

  let cate;
  if(activity.category===null){
    cate = [];
  }else{
    cate = typeof activity.category === "string"
          ? activity.category.split(",").map(item => item.trim())
          : [];
  }
  const [categories, addCategory] = useState(cate);
  const [showPopup, setShowPopup] = useState(false);
  const [partnerId, setPartnerId] = useState(activity?.ownerID);
  const [partnerName, setPartnerName] = useState(activity?.partnerName);
  const modules = {
    toolbar: [
      [{ 'font': ['monospace'] }],
      [{ 'align': [false,'center','right'] }],
      [{ 'list': 'bullet' }],
      ['bold', 'italic', 'underline'],
      ['link'],[{ 'size': ['small', false, 'large', 'huge'] }]
    ],
  };
  const formats = [
    'font',
    'align',
    'list',
    'bold', 'italic', 'underline', 'strike',
    'size',
  ];

    const [response, setResponse] = useState("");
    const [childPriceOption, setChildPriceOption] = useState(activity.childStripePaymentID ? 'allowed'  : 'notAllowed');
    const [subtype, setsubtype] = useState(() => {
        // 1. Ensure subCategoryID is a string (even if undefined/null)
        const subCategoryIDString = activity.subCategoryId?.toString() || '';

        // 2. Split and parse safely
        return subCategoryIDString
            .split(',')
            .map(item => parseInt(item.trim(), 10))
            .filter(item => !isNaN(item)); // Remove invalid numbers
    });
    const [resetFlag, setResetFlag] = useState(false);

    const [subCategory, setsubCategory] = useState([]);


    async function GetAllSubCategories() {
        try {
            const response = await FetchService.GetAllSubCategories();
            return response.data;  // Assuming response.data is an array of subCategory
        } catch (error) {
            console.error("Error fetching subCategory:", error);
            return [];
        }
    }
    useEffect(() => {
        const fetchsubCategory = async () => {
            try {
                const data = await GetAllSubCategories();
                const formattedData = data.map(sub => ({
                    value: sub.name,
                    id: sub.id
                }));
                
                setsubCategory(formattedData);
            } catch (error) {
                console.error("Error fetching subCategory:", error);
            }
        };

        fetchsubCategory(); // Call the function

    }, []); // Empty dependency array ensures it runs only once





  const handleChildPriceChange = (event) => {
      setChildPriceOption(event.target.value);
  };

    const filters = getFilters("add");


    async function convertImageToBase64(imageUrl) {
        const response = await fetch(imageUrl);
        const blob = await response.blob();

        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    }


  const handleSubmit = async (e) => {
      e.preventDefault();
    if (images === null || images.length == 0) {
      alert("Error: Images cannot be empty");
    } else {
        setIsLoading(true);
      activityRequest.id = activity.id;
      activityRequest.ownerID = activity.ownerID;
      activityRequest.stripePaymentID = activity.stripePaymentID;
        activityRequest.stripeProductID = activity.stripeProductID;
        activityRequest.isTransportFree = activity.isTransportFree;
        activityRequest.isTransportPartner = activity.isTransportPartner;
        activityRequest.transportPartnerPrice = activity.transportPartnerPrice;
        activityRequest.name = name;

        let cityE = "";
        city.forEach((categoryE, index) => {
            if (index !== 0) {
                cityE += ", " + categoryE;
            } else {
                cityE += categoryE;
            }
        })

        activityRequest.city = cityE;

      activityRequest.priceModel = priceModel;

      activityRequest.price = +price;
      activityRequest.originalPrice = +originalPrice;

        if (childPriceOption == "notAllowed") {
            activityRequest.childprice = 0;
            activityRequest.childoriginalPrice = 0;
            activityRequest.childStripePaymentID = activity.childstripePaymentID;
            activityRequest.childStripeProductID = activity.childStripeProductID;
        }
        else {
            activityRequest.childprice = +childprice;
            activityRequest.childoriginalPrice = +childoriginalPrice;
            activityRequest.childStripePaymentID = activity.childstripePaymentID;
            activityRequest.childStripeProductID = activity.childStripeProductID;

        }


      activityRequest.validPeriodEnd = validPeriodEnd;
      activityRequest.validPeriodStart = validPeriodStart;

      activityRequest.liveDate = liveDate;

      activityRequest.terms = terms;

      activityRequest.description = description;
      activityRequest.minPerson = +minPerson;
      activityRequest.maxPerson = +maxPerson;
      
      categories.forEach((categoryE,index)=>{
        if(index!==0){
          activityRequest.category += ", " + categoryE;
        }else{
          activityRequest.category = categoryE;
        }
      })


    let subtypeID = "";
    subtype.forEach((categoryE, index) => {
        if (index !== 0) {
            subtypeID += "," + categoryE;
        } else {
            subtypeID += categoryE;
        }
    })
        activityRequest.subCategoryID = subtypeID;
      activityRequest.activityType = type;
      activityRequest.discountPercent =
        100 - (price / originalPrice) * 100 || 0;

        activityRequest.ownerID = partnerId;



    activityRequest.images = images
        ? await Promise.all(images.map(async (x) => {
            if (x.data_url) {
                return x.data_url;
            } else if (x.imageURL) {
                // Convert imageURL to Base64
                return await convertImageToBase64(
                    x.imageURL.replace(
                        "{baseApiURL}",
                        API.apiURLs)
                );
            }
            return null; // Handle cases where neither data_url nor imageURL exists
        })) : [];

        activityRequest.ImagePath = JSON.parse(activity.images)?.map((x) => x.imageURL?.replace(
            "{baseApiURL}","")).filter(obj=>obj);


      activityRequest.instagram = instagram ?? null;
      activityRequest.facebook = facebook ?? null;
      activityRequest.youtube = youtube ?? null;
      activityRequest.cancellationDeadlineDays = hasCancellation ? deadlineDays : null;

      FetchService.UpdateActivity(activityRequest).then((response) => {
        if (response) {
            setSession(null);

          //let session = getSession();
          //if(session)
          //{

          //  let obj = session.activity.filter(x=>x.id==activityRequest.id)[0];
          //  obj.name=name;
          //  obj.images=JSON.stringify(activityRequest.images.map(x=>{return {imageURL:x}})) ;
          //  obj.price=activityRequest.price;
          //  obj.priceModel=obj.priceModel;
          //  setSession(session);
          //}

          setResponse("Success");
          clearForm();
          window.scrollTo(0, 0);
          setIsLoading(false);
        } else {
          setResponse("Failed");
          window.scrollTo(0, 0);
          setIsLoading(false);
        }
      });
    }
  };

  useEffect(()=>{
    if(activity?.terms!==null){
      const terms = String(activity.terms);
      setTerms(activity.terms)
    }
  },[activity.terms])

  function clearForm() {
    setName("");
    setPrice(0);
    setOriginalPrice(0);
    setMinPerson(0);
    setMaxPerson(0);
    setValidPeriodEnd("");
    setValidPeriodStart("");
    setDescription("");
    setTerms("");
    setLiveDate("");
    setFacebook("");
    setInstagram("");
    setYoutube("");
    setImages([]);
    setActivity([]);
    setHasCancellation(false);
    setDeadlineDays(false);
  }

  const DeleteActivity = () => {
    setIsLoading(true);

    FetchService.DeleteActivity(activity).then((response) => {
      if (response) {
        setSession(null);
        setTimeout(() => {
          setResponse("Success");
          clearForm();

          setIsLoading(false);
        }, 1000);
      } else {
        setTimeout(() => {
          setResponse("Failed");

          setIsLoading(false);
        }, 1000);
      }
    });
  };



  function setSession(obj) {
    sessionStorage.setItem("SearchResultAdmin", JSON.stringify(obj));
  }

  const handleTerms = (props) =>{
    setTerms(props)
  }

  const handleDesc = (props) =>{
    setDescription(props)
  }

  function getCategoryName(categoryVal){
    const categoriesLabels = getAllActivityCategories();
    const nameCategory = categoriesLabels.filter(categoryLabel => categoryLabel.value == categoryVal);
    return nameCategory[0].label;
  }

    const deleteCategory = (event) => {
        
        const delCategory = event.currentTarget.dataset.category; // Correct way to get data attribute
        if (categories.length <= 1) {
            return; // Avoids removing the last category
        }
        return addCategory(categories.filter(categoryF => categoryF !== delCategory))
    };

  function getSession() {
    return JSON.parse(sessionStorage.getItem("SearchResultAdmin"));
  }

  return (
    <>
      <div className="Register_page">
        {/* Todo: might need to change this in future for better design
        <InnerHeader HeaderHeading="Activity" PageText="Add Activity" />
     */}

        <section>
          <div className="container">
            {showConfirmDelete && (
              <DialogueBox
                title={"Bekreft sletting"}
                onConfirm={DeleteActivity}
                onConfirmState={null}
                confirmText={"Slette"}
                cancelText={"Avbryt"}
                open={showConfirmDelete}
                setOpen={setShowConfirmDelete}
                stayOnPage={true}
              >
                Er du sikker på at du vil slette denne aktiviteten?
              </DialogueBox>
            )}
            <div className="row row_custom data-grid">
              <div className="">
                <div className="">
                   <h2 className="form_heading inner_header_main">
                    Oppdater aktivitet
                  </h2>
                  {response === "Failed" && (
                    <div className="error_message">
                      {
                        "Feil: Systemet kunne ikke lagre aktiviteten. Vær så snill, prøv på nytt."
                      }
                    </div>
                  )}
                  {response === "Success" && (
                    <div className="success_message">
                      {"Aktiviteten er oppdatert."}
                    </div>
                  )}

                  <form onSubmit={handleSubmit} className="row">
                   <div className="row row_custom_inr row_custom_inr1">

                     <div class="col-lg-6 col_input_otr">
                      <div className="Input_otr">
                        <Input
                          InputClass="Theme_input_white form_input"
                          Inputype="text"
                          InputName="name"
                          label="Aktivitetsnavn"
                          value={name}
                          onChange={(event) => setName(event.target.value)}
                        />
                      </div>
                      <div className="Input_otr">
                         {"Kategori B2C"}
                        <Form.Select
                          className="Theme_input_white form_input"
                          aria-label="Default select example"
                          value={category}
                          onChange={(event) => {
                            if(!categories.includes(event.target.value)) {
                              addCategory(categories.concat(event.target.value));
                              setCategory(event.target.value);
                            }
                          }}
                        >
                          {filters.categories.map((option) => (
                            <option value={option.value}>
                                  {categories.includes(option.value) ? "✔" : (<p>&nbsp;&nbsp;&nbsp;</p>)} {option.label}
                            </option>
                          ))}
                        </Form.Select>
                                              <div className="dflex">
                                                  {categories.map(categoryOne => (
                                                      <div className="my-1 btn btn-primary-form">
                                                          <i
                                                              onClick={deleteCategory}
                                                              data-category={categoryOne} // ✅ Add dataset attribute
                                                              className="ri-delete-bin-5-line">
                                                          </i>{getCategoryName(categoryOne)}
                                                      </div>
                                                  ))}
                                              </div>
                                          </div>
                      <div className="Input_otr">
                                    {"Kategori B2B"}

                                    <Form.Select
                                        key={resetFlag}  // Force re-render on reset
                                        className="Theme_input_white form_input"
                                        aria-label="Default select example"
                                        value={subtype?.length > 0 ? subtype[subtype?.length - 1] : ""}
                                        onChange={(event) => {
                                            const selectedValue = event.target.value === "" ? null : parseInt(event.target.value);

                                            if (selectedValue === null) {
                                                setsubtype([]);
                                                setResetFlag((prev) => !prev); // Change key to trigger re-render
                                            } else if (!subtype.includes(selectedValue)) {
                                                setsubtype([...subtype, selectedValue]);
                                            }
                                        }}
                                    >
                                        <option value="">ⓧ Ingen</option>
                                        {subCategory.map((option) => (
                                            <option key={option.id} value={option.id}>
                                                {subtype.includes(option.id) ? "✔" : " "} {option.value}
                                            </option>
                                        ))}
                                    </Form.Select>


                                    {subtype && subtype.length > 0 && subCategory.length > 0 && <div className="dflex">
                                        {subtype.map(categoryOne => (
                                            <div className="my-1 btn btn-primary-form">
                                                <i onClick={(event) => {
                                                    setsubtype(subtype.filter(cityf => cityf !== categoryOne));
                                                }} key={categoryOne} class="ri-delete-bin-5-line"></i>{subCategory.filter(x => x.id == categoryOne)[0].value}
                                            </div>
                                        ))}
                                    </div>
                                    }


                                </div>
                      <div className="Input_otr">
                                    {"By"}
                                    <Form.Select
                                        className="Theme_input_white form_input"
                                        aria-label="Default select example"
                                        value={city[city.length - 1]}
                                        onChange={(event) => {
                                            if (!city.includes(event.target.value)) {
                                                setCity([...city, event.target.value]);
                                            }


                                        }}
                                    >
                                        {filters.cities.map((option) => (
                                            <option value={option.value}>
                                                {city.includes(option.value) ? "✔" : (<p>&nbsp;&nbsp;&nbsp;</p>)}  {option.label}
                                            </option>
                                        ))}
                                    </Form.Select>
                                    <div className="dflex">
                                        {city.map(categoryOne => (
                                            <div className="my-1 btn btn-primary-form">
                                                <i onClick={(event) => {
                                                    setCity(city.filter(cityf => cityf !== categoryOne));
                                                }} key={categoryOne} class="ri-delete-bin-5-line"></i>{categoryOne}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                      <div className="Input_otr">
                        {"Aktivitetstype"}
                        <Form.Select
                          className="Theme_input_white form_input"
                          aria-label="Default select example"
                          value={type}
                          onChange={(event) => {
                            setType(event.target.value);
                          }}
                        >
                          {filters.types.map((option) => (
                            <option value={option.value}>{option.label}</option>
                          ))}
                        </Form.Select>
                                          </div>
                    </div>
                     <div className="col-lg-6 col_img_otr">
                                              <div className="col_img_inr">
                                                  <div className="image-uploader">
                                                      {/*{!showImagePreview && (*/}
                                                      {/*  <Swiper*/}
                                                      {/*    slidesPerView={1}*/}
                                                      {/*    spaceBetween={24}*/}
                                                      {/*    effect={"fade"}*/}
                                                      {/*    pagination={{*/}
                                                      {/*      clickable: true,*/}
                                                      {/*    }}*/}
                                                      {/*    autoplay={{*/}
                                                      {/*      delay: 2500,*/}
                                                      {/*      disableOnInteraction: false,*/}
                                                      {/*    }}*/}
                                                      {/*    modules={[EffectFade, Autoplay, Pagination]}*/}
                                                      {/*    className="mySwiper hero_swiper campaign_swiper"*/}
                                                      {/*  >*/}
                                                      {/*    {images?.map((image) => (*/}
                                                      {/*      <SwiperSlide>*/}
                                                      {/*        <div className="img_otr">*/}
                                                      {/*          <img*/}
                                                      {/*            className="campaign_img"*/}
                                                      {/*            height="50"*/}
                                                      {/*            width="100%"*/}
                                                      {/*            src={image.imageURL.replace(*/}
                                                      {/*              "{baseApiURL}",*/}
                                                      {/*               "https://www.funtlers.com/"*/}
                                                      {/*            )}*/}
                                                      {/*            alt="img"*/}
                                                      {/*          />*/}
                                                      {/*        </div>*/}
                                                      {/*      </SwiperSlide>*/}
                                                      {/*    ))}*/}
                                                      {/*  </Swiper>*/}
                                                      {/*)}*/}
                                                      <ImageUploader
                                                          showImagePreview={showImagePreview}
                                                          setShowImagePreview={setShowImagePreview}
                                                          setImagesCallBack={setImages}
                                                          imagesUpload={images}
                                                          editMode={true}
                                                      />
                                                  </div>
                                              </div>
                                          </div>
                                      

                                        
                    </div>


                    <div class="row row_custom_inr row_custom_inr1">
                                          <div class="col-lg-6 col_input_otr">
                                              <div class="mb-2 mt-3">
                                                  <h6>Alternativ for barnas pris:</h6>
                                              </div>
                                              <div className="row section-form">

                                                  <div className="row">

                                                      <label>
                                                          <input
                                                              type="radio"
                                                              name="childPrice"
                                                              value="notAllowed"
                                                              checked={childPriceOption === 'notAllowed'}
                                                              onChange={handleChildPriceChange}
                                                          />
                                                          Barnas pris ikke tillatt
                                                      </label>
                                                      <label>
                                                          <input
                                                              type="radio"
                                                              name="childPrice"
                                                              value="allowed"
                                                              checked={childPriceOption === 'allowed'}
                                                              onChange={handleChildPriceChange}
                                                          />
                                                          Barnas pris tillatt
                                                      </label>
                                                  </div>


                                                  <div className="new-line"></div><h6>Antall voksen:</h6>

                                                  <div className="Input_otr col ">
                                                      <Input
                                                          InputClass="Theme_input_white form_input"
                                                          Inputype="number"
                                                          InputName="number"
                                                          label="Pris"
                                                          value={price}
                                                          onChange={(event) =>
                                                              setPrice(event.target.value)
                                                          }
                                                      />
                                                  </div>
                                                  <div className="Input_otr col ">
                                                      <Input
                                                          InputClass="Theme_input_white form_input"
                                                          Inputype="number"
                                                          InputName="number"
                                                          label="Orginalpris"
                                                          value={originalPrice}
                                                          onChange={(event) =>
                                                              setOriginalPrice(event.target.value)
                                                          }
                                                      />

                                                  </div>

                                                  {childPriceOption === 'allowed' && (
                                                      <>
                                                          <h6>Antall barn:</h6>
                                                          <div className="Input_otr col">
                                                              <Input
                                                                  InputClass="Theme_input_white form_input"
                                                                  Inputype="number"
                                                                  InputName="number"
                                                                  label="Pris"
                                                                  value={childprice}
                                                                  onChange={(event) => setChildPrice(event.target.value)}
                                                              />
                                                          </div>
                                                          <div className="Input_otr col">
                                                              <Input
                                                                  InputClass="Theme_input_white form_input"
                                                                  Inputype="number"
                                                                  InputName="number"
                                                                  label="Orginalpris"
                                                                  value={childoriginalPrice}
                                                                  onChange={(event) =>
                                                                      setchildOriginalPrice(event.target.value)
                                                                  }
                                                              />
                                                          </div>
                                                      </>
                                                  )}
                                              </div>
                                              <div className="Input_otr ">
                                                  <label class="label_input heading-xs">Pristype</label>
                                                  <Form.Select
                                                      className="Theme_input_white form_input"
                                                      aria-label="Default select example"
                                                      value={priceModel}
                                                      onChange={(event) => {
                                                          setPriceModel(event.target.value);
                                                      }}
                                                  >
                                                      {priceModelArray.map((option) => (
                                                          <option value={option.value}>{option.label}</option>
                                                      ))}
                                                  </Form.Select>
                                              </div>

                                              <div className="row">
                                                  <div className="Input_otr col">
                                                      <Input
                                                          InputClass="Theme_input_white form_input"
                                                          Inputype="number"
                                                          InputName="number"
                                                          label="Minimumspersoner"
                                                          value={minPerson}
                                                          onChange={(event) => setMinPerson(event.target.value)}
                                                      />
                                                  </div>
                                                  <div className="Input_otr col">
                                                      <Input
                                                          InputClass="Theme_input_white form_input"
                                                          Inputype="number"
                                                          InputName="number"
                                                          label="Maksimumspersoner"
                                                          value={maxPerson}
                                                          onChange={(event) => setMaxPerson(event.target.value)}
                                                      />
                                                  </div>
                                              </div>
                                              <div className="row  section-form bg-lightgray">
                                                  <div class="mb-2 mt-1">
                                                      <h6>Spesifikke Avbestillingsvilkår?{" "}</h6>
                                                  </div>
                                                  <label>
                                                      <input
                                                          type="radio"
                                                          checked={hasCancellation}
                                                          onChange={() => { setHasCancellation(true); setDeadlineDays(1); }}
                                                      />JA
                                                      <input
                                                          className="ml-4"
                                                          type="radio"
                                                          checked={!hasCancellation}
                                                          onChange={() => { setHasCancellation(false); setDeadlineDays(null); }}
                                                      />NEI
                                                  </label>
                                                  {hasCancellation && (
                                                      <div className="input-group mb-2 mt-3">
                                                          <button
                                                              type="button"
                                                              className="btn bg-orange"
                                                              onClick={() =>
                                                                  setDeadlineDays((prev) =>
                                                                      Math.max(1, parseInt(prev || "1", 10) - 1)
                                                                  )
                                                              }
                                                          >
                                                              -
                                                          </button>

                                                          <input
                                                              type="text"
                                                              inputMode="numeric"
                                                              className="form-control bg-transparent text-center"
                                                              value={deadlineDays}
                                                              onChange={(e) => {
                                                                  let val = e.target.value;

                                                                  // Allow empty while typing
                                                                  if (val === "") {
                                                                      setDeadlineDays("");
                                                                      return;
                                                                  }

                                                                  // Remove leading zeros
                                                                  if (val.length > 1) {
                                                                      val = val.replace(/^0+/, "");
                                                                  }

                                                                  // Only digits allowed
                                                                  if (!/^\d+$/.test(val)) return;

                                                                  // Always keep >= 1
                                                                  setDeadlineDays(parseInt(val, 10));
                                                              }}
                                                              onBlur={() => {
                                                                  // If left empty on blur → reset to 1
                                                                  if (deadlineDays === "" || parseInt(deadlineDays, 10) < 1) {
                                                                      setDeadlineDays(1);
                                                                  }
                                                              }}
                                                          />

                                                          <button
                                                              type="button"
                                                              className="btn bg-orange"
                                                              onClick={() =>
                                                                  setDeadlineDays((prev) =>
                                                                      prev === "" ? 1 : parseInt(prev, 10) + 1
                                                                  )
                                                              }
                                                          >
                                                              +
                                                          </button>
                                                      </div>
                                                  )}
                                              </div>
                                          </div>
                                         
                                          <div class="col-lg-6 col_img_otr">
                                             <div className="row" style={{ minHeight: 592 }}>
                                                  <TransportSelector
                                                      onSelectionChange={({ isTransportPartner, isTransportFree, transportPartnerPrice }) => {
                                                          
                                                          activity.isTransportPartner = isTransportPartner || false;
                                                          activity.isTransportFree = isTransportFree || false;
                                                          activity.transportPartnerPrice = transportPartnerPrice || 0;

                                                      }}
                                                      activity={activity}  // 👈 passing the pre-filled data

                                                  />
                                              </div>
                                          </div>
                                      </div>

                 

                  

                    <div className="row">
                      <div className="Input_otr col">
                        <Input
                          InputClass="Theme_input_white form_input"
                          Inputype="date"
                          InputName="number"
                          label="Gyldig fra"
                          value={validPeriodStart}
                          onChange={(event) =>
                            setValidPeriodStart(event.target.value)
                          }
                        />
                      </div>
                      <div className="Input_otr col">
                        <Input
                          InputClass="Theme_input_white form_input"
                          Inputype="date"
                          InputName="number"
                          label="Gyldig Til"
                          value={validPeriodEnd}
                          onChange={(event) =>
                            setValidPeriodEnd(event.target.value)
                          }
                        />
                      </div>
                      <div className="Input_otr col">
                        <Input
                          InputClass="Theme_input_white form_input"
                          Inputype="date"
                          InputName="number"
                          label="Live fra"
                          value={liveDate}
                          onChange={(event) => setLiveDate(event.target.value)}
                        />
                      </div>
                    </div>
                    <div className="Input_otr">
                      <Input
                        optional={true}
                        InputClass="Theme_input_white form_input"
                        Inputype="text"
                        InputName="facebook"
                        label="Facebook (Valgfri)"
                        value={facebook}
                        onChange={(event) => setFacebook(event.target.value)}
                      />
                    </div>

                    <div className="Input_otr">
                      <Input
                        optional={true}
                        InputClass="Theme_input_white form_input"
                        Inputype="text"
                        InputName="youtube"
                        label="Instagram (Valgfri)"
                        value={instagram}
                        onChange={(event) => setInstagram(event.target.value)}
                      />
                    </div>
                    <div className="Input_otr">
                      <Input
                        optional={true}
                        InputClass="Theme_input_white form_input"
                        Inputype="text"
                        InputName="youtube"
                        label="Youtube (Valgfri)"
                        value={youtube}
                        onChange={(event) => setYoutube(event.target.value)}
                      />
                    </div>

                    <div className="Input_otr">
                      <label className="label_input heading-xs">
                        Beskrivelse
                      </label>

                      {/* <textarea
                        className="Theme_input_white form_input description"
                        type="text"
                        name="description"
                        value={description}
                        onChange={(event) => setDescription(event.target.value)}
                      /> */}
                        <ReactQuill
                          className="Theme_input_white form_input description"
                          modules={modules}
                          formats={formats}
                          onChange={handleDesc}
                          name="description"
                          value={description}
                        />

                    </div>
                    <div className="Input_otr">
                      <label className="label_input heading-xs">Vilkår</label>

                      {/* <textarea
                        className="Theme_input_white form_input description"
                        type="text"
                        name="terms"
                        value={terms}
                        onChange={(event) => setTerms(event.target.value)}
                      /> */}

                      <ReactQuill
                          className="Theme_input_white form_input description"
                          modules={modules}
                          formats={formats}
                          onChange={handleTerms}
                          name="terms"
                          value={terms}
                        />
                    </div>

                    <div className="change-partner">
                      {/* Add activity button if the partner is not attached. */}
                      {partnerId !== 0 && (
                      <div className="Input_otr section-form bg-sec">
                          <div class="row partner-sec">
                              <div> <button
                                type="button"
                                className="form_btn Theme_btn_primary btn-primary-form"
                                onClick={() => {
                                    setShowPopup(true);
                                }}
                            >
                                <i class="ri-delete-bin-5-line"></i> Bytte partner
                            </button></div>
                                                      <div class="p12">
                                <b>Partner Id: </b> {partnerId} 
                            </div>
                                                      <div class="p12">
                                <b>Partnernavn: </b> {partnerName}
                              </div>
                           </div>
                        </div>
                      )}
                    
                    </div>

                    <div className="Input_otr">
                      <button
                        type="submit"
                        className="Theme_btn_primary form_btn"
                      >
                        Oppdater aktivitet
                      </button>
                    </div>
                  <div className="Input_otr">
                      <button
                        type="button"
                        onClick={() => setShowConfirmDelete(true)}
                        className="Theme_btn_primary form_btn bg-danger"
                      >
                        Slette aktivitet
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>

        {showPopup && (
          <div className="backdrop">
            <div className="backdrop-container">
              <AttachActivity
                setShowPopup={setShowPopup}
                setPartnerID={setPartnerId}
                setPartnerName={setPartnerName}
              />
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default EditActivity;
